'use client';

import { parseCacheControlMaxAge } from '@/utils/cache-control';
import { useQueryClient } from '@tanstack/react-query';

export const useDynamicStaleTime = (): (queryKey: readonly unknown[], headers?: Headers | null) => void => {
  const queryClient = useQueryClient();

  const updateQueryStaleTime = (queryKey: readonly unknown[], headers?: Headers | null): void => {
    const cacheControl = headers?.get('cache-control');
    const maxAge = parseCacheControlMaxAge(cacheControl);
    if (cacheControl) {
      queryClient.setQueryDefaults(queryKey, {
        gcTime: maxAge,
        staleTime: maxAge,
      });
    }
  };

  return updateQueryStaleTime;
};
